import React, {useState, useEffect} from "react";

import './Team.rename.dialog.scss';
import Modal from "react-modal";
import Input from "../../forms/inputs/Input";
import {useMutation} from "@apollo/client";
import gqlSchemaLibrary from "../../services/graphql.schemas";
import {useTranslation} from "react-i18next";
import {ModalLog} from "../../services/interactions/elements/modal";
import AuditTrail from "../../services/interactions/audit.trail";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};
Modal.setAppElement('#root');

const _Modal = ModalLog(Modal);

function TeamRenameDialog({event, team, openModal, closeModal}) {
    const {t} = useTranslation(['common','teams']);
    const [name, setName] = useState('');
    const [__submitting, __setSubmitting] = useState(false);

    useEffect(() => {
        setName(team.name);
    }, [openModal])

    const [editTeam] = useMutation(gqlSchemaLibrary.teams.mutation.editTeam, {
        onCompleted: ({ renameTeam }) => {
            __setSubmitting(false);
            closeModal(name);
        },
        onError: (e) => {
            console.error('Rename Team Error: ', e);
            __setSubmitting(false);
        }
    });

    const closeModalEmpty = () => {
        AuditTrail.sendLog(event, {tag: 'button', event: 'closeModal', action: 'button modal cancel delete teams', team_id: team._id});
        closeModal();
    }

    const onChangeName = (e) => {
        setName(e);
    }

    const onSave = () => {
        if (!name || __submitting) {
            return;
        }
        AuditTrail.sendLog(event, {tag: 'button', event: 'onClick', action: 'button rename team', team_id: team._id});
        __setSubmitting(true);
        editTeam({
            variables: {
                team: {
                    _id: team._id,
                    name: name
                }
            }
        });
    }

    return (
        <_Modal
            isOpen={!!openModal}
            style={customStyles}
            onRequestClose={closeModalEmpty}
            contentLabel="Rename team"
            label="TeamRenameDialog"
            event={event}
            eventParams={{team_id: team._id}}>
            <div id="TeamRenameDialog">
                <div className="__MembersTitle">
                    <i className="material-icons" onClick={closeModalEmpty}>arrow_back_ios</i>
                    <h3>{t('rename')} {t('teams:team')} <b>{team.name}</b></h3>
                </div>
                <div className="__Container">
                    <div className="row">
                        <Input required={true} label={t('name')} value={name} max={100} onChange={onChangeName} event={event}/>
                    </div>
                    <div className="containerButtons">
                        <button className="primary gray" onClick={closeModalEmpty}>
                            {t('cancel')}
                        </button>
                        <button disabled={!name} className="primary blue" onClick={onSave}>
                            {t('save')}
                        </button>
                    </div>
                </div>
            </div>
        </_Modal>
    );
}

export default TeamRenameDialog;
